function applyGliderCard(){

  const gliderCards = new Glider(document.querySelector(".gliderCard"), {
    slidesToShow: 3,
    dots: ".dots",
    draggable: true,
    arrows: {
      prev: ".glider-prev-cards",
      next: ".glider-next-cards"
    },
    responsive: [
      { // screens greater than >=300px
        breakpoint: 300,
        settings: { // Set to `auto` and provide item width to adjust to viewport
          slidesToShow: 1,
          slidesToScroll: "auto",

          duration: 0.25
        }
      }, { // screens greater than >= 1024px
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          itemWidth: 150,
          duration: 0.25
        }
      }
    ]
  })



}

setTimeout(function() {
  applyGliderCard();
}, 200);


document.addEventListener('shopify:section:load', function(event){

  applyGliderCard();

});

document.addEventListener('shopify:block:select', function(event) {

  applyGliderCard();
});












